export class ListDialogController {
  public static $inject = ['$mdDialog', '$translate', 'title', 'list', 'okText', 'cancelText'];
  public title: string;
  public list: Array<any>;
  public okText: string;
  public cancelText: string;
  public currentLocale: string;
  public selectedItem: any;

  constructor(
    private $mdDialog: ng.material.IDialogService,
    $translate: ng.translate.ITranslateService,
    title: string,
    list: Array<any>,
    okText: string,
    cancelText: string
  ) {
    this.currentLocale = $translate.use();
    this.title = $translate.instant(title);
    this.okText = !okText ? $translate.instant('DIALOG_COMMON.YES') : $translate.instant(okText);
    this.cancelText = !cancelText ? $translate.instant('DIALOG_COMMON.NO') : $translate.instant(cancelText);
    this.list = list;
  }

  public setSelectedItem(item: any) {
    this.selectedItem = item;
  }

  public ok = () => {
    this.$mdDialog.hide(this.selectedItem);
  }

  public cancel = () => {
    this.$mdDialog.cancel();
  }
}